import { TrackLogActionEnum } from 'constants/logger';
import { trackToLogger } from './logger';

type IRequestConfig = { url: string } & RequestInit;
/** 简单封装下，增加打点上报 */
export function customFetch(params: IRequestConfig) {
  const { url, ...options } = params;

  const method = options?.method?.toUpperCase() ?? 'GET';
  const startTimestamp = Date.now();

  const body = typeof options?.body === 'string' ? options?.body : undefined;
  return fetch(url, options)
    .then((res) => {
      trackToLogger({
        logAction: TrackLogActionEnum.RES,
        logContent: {
          url,
          method,
          status: res?.status ?? 0,
          startTimestamp,
          endTimestamp: Date.now(),
          reqData: res.ok ? undefined : body,
        },
      });

      return res;
    })
    .catch((err) => {
      trackToLogger({
        logAction: TrackLogActionEnum.RES,
        logContent: {
          url,
          method,
          status: 0,
          startTimestamp,
          endTimestamp: Date.now(),
          reqData: body,
          message: err?.message,
        },
      });
      throw err;
    });
}
